namespace $.$$ {

	$mol_style_define( $shm_ba_summary, {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fit,minmax(160px,1fr))',
		gap: '12px',
		userSelect: 'text',
	} )

}
